import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFacturen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="m9.32 31.66 17.83 2.44 2.78-20.24.38-2.77.37-2.75L18.2 6.63l-5.35-.73-.76 5.52z"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M11 33h18V7H11v26"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M20 10.5h-7v1h7zM21 13.5h-8v1h8zM20 16.5h-7v1h7zM27 16.51h-4.01v1H27z"
    />
    <path
      fill="#00215B"
      d="M25.49 15h-1v4.01h1z"
    />
    <path
      fill="#0061CD"
      d="M14.07 27.8H13v-1.6h1.07c.38-1.83 2.04-3.2 4.03-3.2a4.2 4.2 0 0 1 2.91 1.17l-1.28 1.09c-.44-.43-1.02-.67-1.63-.67-1.01 0-1.9.66-2.22 1.6h2.39v1.6h-2.39c.33.94 1.21 1.6 2.22 1.6.61 0 1.19-.24 1.63-.67l1.28 1.09c-.74.72-1.77 1.17-2.91 1.17-1.99 0-3.65-1.37-4.03-3.2z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFacturen);

export default ForwardRef;
